import _defineProperty from "/Users/sdq/GitHub/visact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _scales;

import invertRange from './scales/invertRange';
import invertRangeExtent from './scales/invertRangeExtent';
import { Identity, Linear, Log, Pow, Sqrt, Symlog, Time, UTC, Sequential, Diverging, Quantile, Quantize, Threshold, BinOrdinal, Ordinal, Band, Point } from './scales/types';
import { band as scaleBand, point as scalePoint } from './scales/scaleBand';
import { scaleBinOrdinal } from './scales/scaleBinOrdinal';
import * as $ from 'd3-scale';
/**
 * Augment scales with their type and needed inverse methods.
 */

function create(type, constructor) {
  return function scale() {
    var s = constructor();

    if (!s.invertRange) {
      s.invertRange = s.invert ? invertRange(s) : s.invertExtent ? invertRangeExtent(s) : undefined;
    }

    s.type = type;
    return s;
  };
}

export default function scale(type, scale) {
  if (arguments.length > 1) {
    scales[type] = create(type, scale);
    return this;
  } else {
    return scales.hasOwnProperty(type) ? scales[type] : undefined;
  }
}
var scales = (_scales = {}, _defineProperty(_scales, Identity, $.scaleIdentity), _defineProperty(_scales, Linear, $.scaleLinear), _defineProperty(_scales, Log, $.scaleLog), _defineProperty(_scales, Pow, $.scalePow), _defineProperty(_scales, Sqrt, $.scaleSqrt), _defineProperty(_scales, Symlog, $.scaleSymlog), _defineProperty(_scales, Time, $.scaleTime), _defineProperty(_scales, UTC, $.scaleUtc), _defineProperty(_scales, Sequential, $.scaleSequential), _defineProperty(_scales, Sequential + '-' + Linear, $.scaleSequential), _defineProperty(_scales, Sequential + '-' + Log, $.scaleSequentialLog), _defineProperty(_scales, Sequential + '-' + Pow, $.scaleSequentialPow), _defineProperty(_scales, Sequential + '-' + Sqrt, $.scaleSequentialSqrt), _defineProperty(_scales, Sequential + '-' + Symlog, $.scaleSequentialSymlog), _defineProperty(_scales, Diverging + '-' + Linear, $.scaleDiverging), _defineProperty(_scales, Diverging + '-' + Log, $.scaleDivergingLog), _defineProperty(_scales, Diverging + '-' + Pow, $.scaleDivergingPow), _defineProperty(_scales, Diverging + '-' + Sqrt, $.scaleDivergingSqrt), _defineProperty(_scales, Diverging + '-' + Symlog, $.scaleDivergingSymlog), _defineProperty(_scales, Quantile, $.scaleQuantile), _defineProperty(_scales, Quantize, $.scaleQuantize), _defineProperty(_scales, Threshold, $.scaleThreshold), _defineProperty(_scales, BinOrdinal, scaleBinOrdinal), _defineProperty(_scales, Ordinal, $.scaleOrdinal), _defineProperty(_scales, Band, scaleBand), _defineProperty(_scales, Point, scalePoint), _scales);

for (var key in scales) {
  scale(key, scales[key]);
}